import React from 'react';
import { CoDriverMcpLoader } from 'client/site-modules/shared/components/co-driver-mcp-loader/co-driver-mcp-loader';
import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const MCPUIToolsResultsAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "mcp-ui-tools-results" */ './mcp-ui-tools-results'),
  loading: () => <CoDriverMcpLoader className="mb-1" />,
  componentName: 'MCPUIToolsResults',
});
